import BaseComponent from "../BaseComponent";
import styles from "./index.module.scss";

const ObjectDataComponent = ({selectedObject}) => {
  return (
    <BaseComponent title="Data" foldable={true}>
      <div className={styles.wrapper}>
        <div className={styles.title}>Class</div>
        <div className={styles.text}>{selectedObject.type}</div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.title}>Name</div>
        <div className={styles.text}>{selectedObject.name}</div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.title}>Parent</div>
        <div className={styles.text}>{selectedObject.parent.name}</div>
      </div>
    </BaseComponent>
  );
};

export default ObjectDataComponent;
